import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Lock, Check } from "lucide-react";
import { GlassCard, SectionTitle } from "./_shared";

const COLOR_MAP = {
  fuchsia: "from-orange-500 to-pink-500",
  violet: "from-black to-black",
  sky: "from-sky-500 to-indigo-500",
  emerald: "from-emerald-500 to-teal-500",
  slate: "from-slate-500 to-slate-600",
};

export default function AdminRoles() {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/roles");
        setRoles(data);
      } catch {
        /* noop */
      }
    })();
  }, []);

  return (
    <div className="space-y-4">
      <SectionTitle icon={Lock}>Matrice des rôles</SectionTitle>
      <div className="space-y-3">
        {roles.map((r) => (
          <GlassCard key={r.id} className="p-4" data-testid={`role-card-${r.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div>
                <div className={`inline-block bg-gradient-to-r ${COLOR_MAP[r.color] || COLOR_MAP.violet} text-[var(--text)] text-[11px] font-bold uppercase tracking-wider rounded-full px-2.5 py-0.5`}>
                  {r.label}
                </div>
                <div className="text-[12px] text-zinc-300 mt-1.5">{r.description}</div>
              </div>
              <div className="text-right">
                <div className="font-display font-bold text-2xl text-[var(--text)] tabular-nums">{r.users_count}</div>
                <div className="text-[10px] text-zinc-400 uppercase">utilisateurs</div>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5 mt-2">
              {r.permissions.map((p, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-1 text-[10px] bg-[var(--surface)] border border-[var(--border)] rounded-full px-2 py-0.5 text-zinc-300 font-mono"
                >
                  <Check className="w-2.5 h-2.5 text-emerald-400" />
                  {p}
                </span>
              ))}
            </div>
          </GlassCard>
        ))}
      </div>
      <div className="text-[11px] text-zinc-400 leading-relaxed px-1">
        Les rôles se configurent au niveau utilisateur dans l'onglet « Utilisateurs ». Le rôle <code className="text-[var(--text)]">super_admin</code> accorde automatiquement <code className="text-[var(--text)]">is_admin=true</code>.
      </div>
    </div>
  );
}
